import {CalculatorBase} from "./CalculatorBase";
import {NumericUtilities} from "../../Utilities/NumericUtilities";
import {FBTextFieldOptions} from "FreeFields/Fields/FBTextField/FBTextField.options";


export class PricePerWordCalculator extends CalculatorBase{

    public ExecuteCalculation(value:any):{RegularPrice:any,SalePrice:any,Quantity:number}    {
        if(value==null)
            value=this.Field.GetValue()
        let match=value.match(/\S+/g);
        let numberOfChars=match==null?0:match.length;

        let freeChars=(this.Field.Options as FBTextFieldOptions).FreeCharOrWords;
        if(freeChars>0)
            numberOfChars=Math.max(0,numberOfChars-freeChars);

        if(value.length>0) {
            if(this.Field.GetSalePrice()!='')
                return {Quantity:this.GetQuantityInput(), RegularPrice:this.Field.GetRegularPrice()!=''?NumericUtilities.ParseNumber(this.Field.GetRegularPrice())*numberOfChars:'',
                    SalePrice:this.Field.GetSalePrice()!=''?NumericUtilities.ParseNumber(this.Field.GetSalePrice())*numberOfChars:''};
            else
                return {Quantity:this.GetQuantityInput(), RegularPrice: this.Field.GetRegularPrice()!=''?NumericUtilities.ParseNumber(this.Field.GetRegularPrice())*numberOfChars:'',SalePrice:''};
        }
        else
            return {RegularPrice:'',SalePrice:'',Quantity:0}
    }



    public ParseNumber(number:any)
    {
        let num=parseFloat(number);
        if(isNaN(num))
            return 0;
        return num;
    }

}

